// extracted by mini-css-extract-plugin
module.exports = {"bottomSectionContainer":"BottomSection_bottomSectionContainer__1KM0Z","bottomSection":"BottomSection_bottomSection__1CD5D","noPadding":"BottomSection_noPadding__YmPvm"};